import { get } from 'lodash';
import { ILayerProps, LayerType } from '@/version-types';

// 递归是否全部为文本组（多选）
export const groupAllText = (layer: ILayerProps): boolean => {
    if (!layer) return false;
    if (layer.layerType === LayerType.GROUP_LAYER) {
        return layer.children.every((item) => groupAllText(item));
    } else if (layer.layerType === LayerType.TEXT_LAYER && !get(layer, 'data.shapeExtension', null)) {
        return true;
    }
    return false;
};
